import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDuGcTBVM4wmwKCGDaJqQY-XOR6b4zTYPg",
  authDomain: "openheart-fd86e.firebaseapp.com",
  projectId: "openheart-fd86e",
  storageBucket: "openheart-fd86e.firebasestorage.app",
  messagingSenderId: "749489342665",
  appId: "1:749489342665:web:9424e049e06d713b18a518",
  measurementId: "G-XJCBQVDCBR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
